import {
  RichTextField,
  withDatasourceCheck,
} from "@sitecore-jss/sitecore-jss-nextjs";
import { ComponentProps } from "@repo/sitecore-lib/component-props";
import * as Flex from "@repo/ui/flex";
import HtmlContent from "../../../html-content/html-content";
import styles from "./faqContent.module.css";

type FAQContentProps = ComponentProps & {
  fields: {
    faqContent: RichTextField;
  };
};

const FAQContent = ({
  fields: { faqContent },
  rendering,
  params,
}: FAQContentProps): JSX.Element => {
  return (
    <Flex.Item className={styles.faqContent} asChild>
      <HtmlContent
        fields={{ Text: faqContent as RichTextField }}
        rendering={rendering}
        params={params}
      />
    </Flex.Item>
  );
};

export default withDatasourceCheck()<FAQContentProps>(FAQContent);
